export default __webpack_public_path__ + "static/media/ga.0ecd76a3.svg";